<template>
  <v-container fluid>
    <div class="text-center text-h3">
      Pareto de Tiempos de Paro por Causa del Mes
    </div>
    <div style="position: relative;">
      <!-- <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <VueCtkDateTimePicker v-model="filtros.inicio" label="Desde" format="YYYY-MM-DD HH:mm"
              formatted="YYYY-MM-DD HH:mm" noHeader buttonNowTranslation="Ahora" class="mr-1" :loading="loading" />
          </v-col>
          <v-col cols="4">
            <VueCtkDateTimePicker v-model="filtros.fin" label="Hasta" format="YYYY-MM-DD HH:mm"
              formatted="YYYY-MM-DD HH:mm" noHeader buttonNowTranslation="Ahora" class="mr-1" :loading="loading" />
          </v-col>
          <v-col cols="4">
            <v-select v-model="filtros.tipo" :items="tipos" item-text="titulo" item-value="valor" label="Tipo"
              :loading="loading" />
          </v-col>
          <v-col>
            <div class="d-flex justify-center align-center">
              <v-autocomplete v-model="filtros.causas" multiple v-if="filtros.tipo === 1" :items="tipoParos"
                item-text="nombre" item-value="idParoTipo" label="Causas" :loading="loading" />
              <v-autocomplete v-model="filtros.subcausas" multiple v-if="filtros.tipo === 2" :items="tipoSubparos"
                item-text="nombreSubParoTipo" item-value="idSubParoTipo" label="SubCausas" :loading="loading" />
              <v-btn color="primary" @click="getRes()" :disabled="!validFilters" class="ml-2" :loading="loading">
                Buscar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col> -->
      <apexchart type="bar" height="350" :options="chartOptions" :series="series" />
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      tipos: [
        { titulo: "Causas", valor: 1 },
        { titulo: "SubCausas", valor: 2 },
      ],
      rawCategories: [],
      rawSeries: [],
      tipoParos: [],
      tipoSubparos: [],
      filtros: {
        inicio: null,
        fin: null,
        tipo: null,
        causas: [],
        subcausas: [],
      },
      loading: false,
    };
  },
  created() {
    // 1) Calcula rango por defecto
    const rango = this.fechaPorDefecto();
    this.filtros.inicio = rango.inicio;
    this.filtros.fin    = rango.fin;

    // 2) Pon un tipo por defecto (digamos Causas)
    this.filtros.tipo = 1;

    this.getTipoParos()
      .then(() => {
        // rellenamos filtros.causas con todos los idParoTipo
        this.filtros.causas = this.tipoParos.map(p => p.idParoTipo);
        // Disparamos la petición al EP con únicamente causas
        this.getRes();
      })
      .catch(console.error);
    },
  computed: {
    // Para habilitar el botón sólo si inicio, fin y tipo están definidos
    validFilters() {
      return this.filtros.inicio && this.filtros.fin && this.filtros.tipo;
    },
    series() {
      return [{
        name: 'Duración',
        data: this.rawSeries,
      }];
    },
    chartOptions() {
      return {
        chart: { height: 350, type: 'bar' },
        plotOptions: {
          bar: {
            columnWidth: '80%',
            distributed: true,
            dataLabels: {
              position: 'top'    // 'top' para arriba, 'center' para dentro, 'bottom' debajo
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -4,         // ajusta separación vertical
          formatter: val => {  // recibe el valor en segundos
            const secs = Math.round(val)
            const h = Math.floor(secs / 3600)
            const m = Math.floor((secs % 3600) / 60)
            const s = secs % 60
            return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
          },
          style: {
            fontSize: '12px',
            colors: ['#000']    // color de la etiqueta
          }
        },
        legend: { show: false },
        xaxis: {
          categories: this.rawCategories,
          labels: { style: { fontSize: '12px' } },
          title: { text: 'Categorías' }
        },
        yaxis: {
          title: { text: 'Tiempo (hh:mm:ss)' },
          labels: {
            formatter: val => {
              const secs = Math.round(val);
              const h = Math.floor(secs / 3600);
              const m = Math.floor((secs % 3600) / 60);
              const s = secs % 60;
              return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
            }
          }
        },
        tooltip: {
          y: {
            formatter: val => {
              const secs = Math.round(val);
              const h = Math.floor(secs / 3600);
              const m = Math.floor((secs % 3600) / 60);
              const s = secs % 60;
              return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
            }
          }
        }
      };
    }
  },
  methods: {
    initialize(){
      this.getTipoParos();
      this.getTipoSubParos();
      this.getRes();
    },
    fechaPorDefecto() {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);

      const pad = n => n < 10 ? '0' + n : n;
      const format = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;

      return {
        inicio: `${firstDay.getFullYear()}-${pad(firstDay.getMonth() + 1)}-01 00:00`,
        fin: format(today)
      };
    },
    // Envía filtros completos al EP
    getRes() {
      this.loading = true;
      axios.post("/Reportes/ReporteParosNiveles", this.filtros)
        .then(({ data }) => {
          this.rawCategories = data.categories;
          this.rawSeries = data.series;
        })
        .catch(err => {
          console.error("Error al obtener los datos:", err);
        })
        .finally(() => {
          this.loading = false;
        })
    },

    getTipoParos() {
    return axios.get("/ParoTipos")
      .then(r => { this.tipoParos = r.data; });
   },
    getTipoSubParos() {
      return axios.get("/SubParoTipos")
        .then(r => { this.tipoSubparos = r.data; });
    },
  }
};
</script>